var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FieldBasics } from '@/components/mambas';
import lodash from 'lodash';
import { Component, Inject, Mixins, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Mixins(FieldBasics) {
    constructor() {
        super(...arguments);
        this.optionLists = [];
        this.extendInfo = [];
        this.readonlyLabel = [];
        this.isInit = true;
        this.loading = false;
        this.currentlyProvide = '';
    }
    get value() {
        return lodash.get(this.formState, this._name);
    }
    set value(value) {
        lodash.set(this.formState, this._name, value);
        this.onChangeValue();
    }
    onValChange(val) {
        if (this.isInit) {
            this.init(val);
            this.isInit = false;
        }
    }
    labelText() {
        return lodash.join(this.readonlyLabel, '/');
    }
    // 获取省份
    async getProvides() {
        try {
            const res = await this.$Store.Common.enterpriseGetProvides();
            lodash.map(res, (item) => lodash.assign(item, {
                label: lodash.get(item, 'name'),
                value: lodash.get(item, 'code'),
                isLeaf: false,
            }));
            this.optionLists = res;
        }
        catch (error) { }
    }
    // 获取城市
    async getCitys(targetOption) {
        try {
            const { value, label } = targetOption;
            if (this._readonly) {
                lodash.set(this.readonlyLabel, '[0]', label);
            }
            this.currentlyProvide = value;
            const res = await this.$Store.Common.enterpriseGetCitys(value);
            targetOption.children = lodash.map(res, (item) => lodash.assign(item, {
                label: lodash.get(item, 'name'),
                value: lodash.get(item, 'code'),
                isLeaf: false,
            }));
            this.optionLists = [...this.optionLists];
            targetOption.loading = false;
        }
        catch (error) { }
    }
    // 获取区县
    async getDistrict(targetOption) {
        try {
            const { value, label } = targetOption;
            if (this._readonly) {
                lodash.set(this.readonlyLabel, '[1]', label);
            }
            const res = await this.$Store.Common.enterpriseGetDistrict({
                provincecode: this.currentlyProvide,
                citycode: value,
            });
            targetOption.children = lodash.map(res, (item) => lodash.assign(item, {
                label: lodash.get(item, 'name'),
                value: lodash.get(item, 'code'),
                isLeaf: true,
            }));
            this.optionLists = [...this.optionLists];
            targetOption.loading = false;
        }
        catch (error) { }
    }
    loadData(selectedOptions) {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        if (selectedOptions.length === 1) {
            this.getCitys(targetOption);
            this.currentlyProvide = lodash.get(targetOption, 'value');
        }
        else if (selectedOptions.length === 2) {
            this.getDistrict(targetOption);
        }
    }
    displayRender({ labels }) {
        if (!lodash.isEmpty(labels)) {
            return `${labels[0]}/${labels[1]}/${labels[2]}`;
        }
        return '';
    }
    async init([mapProvide, mapCity, mapDistrict]) {
        this.loading = true;
        let defaultProvideOpt = lodash.find(this.optionLists, (e) => e.value === mapProvide);
        await this.getCitys(defaultProvideOpt);
        let defaultCityOpt = lodash.find(lodash.get(defaultProvideOpt, 'children'), (e) => e.value == mapCity);
        console.log('🚀 ~ file: address.vue ~ line 147 ~ extends ~ init ~ defaultCityOpt', defaultCityOpt);
        await this.getDistrict(defaultCityOpt);
        if (this._readonly) {
            let defaultDistrict = lodash.find(lodash.get(defaultCityOpt, 'children'), (e) => e.value === mapDistrict);
            lodash.set(this.readonlyLabel, '[2]', lodash.get(defaultDistrict, 'label'));
        }
        this.value = [mapProvide, mapCity, mapDistrict];
        this.loading = false;
    }
    handleData(data) {
        let arr = [];
        let hasEmpty = false;
        lodash.forIn(data, (value, key) => {
            if (!value) {
                hasEmpty = true;
            }
            arr.push({
                field: key,
                value: value,
            });
        });
        if (hasEmpty) {
            return null;
        }
        return arr;
    }
    onChange(value, selectedOptions) {
        if (!selectedOptions || !value) {
            return;
        }
        this.extendInfo = {
            provinceCode: value[0],
            province: lodash.get(selectedOptions, '[0].label'),
            cityCode: value[1],
            city: lodash.get(selectedOptions, '[1].label'),
            districtCode: value[2],
            district: lodash.get(selectedOptions, '[2].label'),
            formattedAddress: `${lodash.get(selectedOptions, '[0].label')}/${lodash.get(selectedOptions, '[1].label')}/${lodash.get(selectedOptions, '[2].label')}`,
        };
        lodash.set(this.formState, 'addressExtendInfo', this.handleData(this.extendInfo));
        this.value = value;
    }
    async mounted() {
        // this.onRequest();
        await this.getProvides();
        if (!lodash.isEmpty(this.value)) {
            this.init(this.value);
        }
        if (this.debug) {
            console.log('');
            console.group(`Field ~ ${this.entityKey} ${this._name} `);
            console.log(this);
            console.groupEnd();
        }
    }
};
__decorate([
    Inject()
], default_1.prototype, "formState", void 0);
__decorate([
    Inject()
], default_1.prototype, "PageEntity", void 0);
__decorate([
    Inject({ default: '' })
], default_1.prototype, "formType", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "onValChange", null);
default_1 = __decorate([
    Component({ components: {} })
], default_1);
export default default_1;
